import type {
  ControlCenterAsset,
  ControlCenterAssetKind,
} from '../types/controlCenter'
import type { FleetEntity } from './tallyFleetEntities'
import { getEntityDriverName } from './tallyFleetEntities'

export function fleetEntityToControlCenterAsset(entity: FleetEntity): ControlCenterAsset {
  const kind: ControlCenterAssetKind = entity.assetTracker ? 'assetTracker' : 'vehicle'
  const status = String(entity.raw.status || '').trim() || 'Unknown'
  const fuelLevel = String(entity.raw.fuelLevel || '').trim() || undefined
  const battery = String(entity.raw.battery || '').trim() || undefined
  const driver = getEntityDriverName(entity) ?? undefined

  return {
    id: entity.key,
    name: entity.displayName,
    assetKind: kind,
    status,
    driver,
    fuelLevel,
    battery,
    lat: entity.lat,
    lng: entity.lng,
    fleetId: entity.fleetId,
    raw: entity.raw,
  }
}

export function matchAssetImageUrls(
  asset: ControlCenterAsset,
  rows: Array<{
    imageUrls?: string[]
    image?: string
    img?: string
    serialNumber?: string
    externalIdentifiers?: {
      vin?: string
      serialNumber?: string
      imei?: string
      deviceUUID?: string
    }
  }>,
): string[] {
  const key = (v: unknown) => String(v || '').trim().toLowerCase()
  const raw = asset.raw || {}
  const vin = key(raw.vin)
  const serial = key(raw.serialNumber || raw.deviceSerialNumber || raw.serial)
  const imei = key(raw.imei)
  const uuid = key(raw.deviceUUID || raw.uuid)
  const match = rows.find((row) => {
    const rowVin = key(row.externalIdentifiers?.vin)
    const rowSerial = key(row.externalIdentifiers?.serialNumber || row.serialNumber)
    const rowImei = key(row.externalIdentifiers?.imei)
    const rowUuid = key(row.externalIdentifiers?.deviceUUID)
    return (
      (!!vin && rowVin === vin) ||
      (!!serial && rowSerial === serial) ||
      (!!imei && rowImei === imei) ||
      (!!uuid && rowUuid === uuid)
    )
  })
  if (!match) return []
  if (Array.isArray(match.imageUrls) && match.imageUrls.length) {
    return match.imageUrls.filter(Boolean)
  }
  return [match.image, match.img].filter(Boolean) as string[]
}
